import api from './api';

export default class PeriodosAvaliacaoEstagioProbatorioService {
  constructor() {
    throw 'Não é possível instanciar PeriodosAvaliacaoEstagioProbatorioService';
  }

  static async lista(id, idMes) {
    const endpoint = mergeEndpoint(id, idMes);
    return await api.get(endpoint);
  }

  static async obtemDoFuncionario(id, idMes) {
    const endpoint = mergeEndpoint(id, idMes);
    const params = { idAvaliado: id };
    return await api.get(endpoint, { params });
  }
}

const mergeEndpoint = (id, idMes) => {
  return `avaliacoes-estagio-probatorio/avaliador/${id}/competencias/${idMes}/avaliacoes-estagio-probatorio`;
};



// WEBPACK FOOTER //
// ./src/services/periodosEstagioProbatorioService.js